<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

export default {
  mixins: [apibtoast, apigeneric],
  props: ["SiteJson"],
  data() {
    return {};
  },
  components: {
    Loader,
  },
  methods: {
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="homepageblocks"
      size="xl"
      :title="$t('homepageblocks.Eye.FormTitle')"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="mb-2">
          <div class="border border-success rounded-3">
            <div class="row p-1">
              <div class="text-center p-3">Slider</div>
            </div>
          </div>
        </div>
        <template v-for="(element, index) in SiteJson">
          <div :key="index" :class="element.col" class="mb-2">
            <div
              class="border border-success rounded-3"
              v-if="element.child.length > 0"
            >
              <div class="row p-1">
                <template v-for="(child, childindex) in element.child">
                  <div :key="childindex" :class="child.col">
                    <div
                      class="text-center p-3"
                      :class="
                        element.child.length > 1
                          ? 'border border-success rounded-3'
                          : ''
                      "
                    >
                      {{ child.name }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>

        <div class="mb-2">
          <div class="border border-success rounded-3">
            <div class="row p-1">
              <div class="text-center p-3">Footer</div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
